import React from 'react';
import { MapContainer, TileLayer, CircleMarker, Popup } from 'react-leaflet';

function CityMap({ data }) {
  if (!data || data.length === 0) {
    return <p className="text-sm text-gray-500">No data</p>;
  }
  // Determine marker size range based on counts
  let minCount = Infinity, maxCount = -Infinity;
  data.forEach(city => {
    if (city.count < minCount) minCount = city.count;
    if (city.count > maxCount) maxCount = city.count;
  });
  if (minCount === Infinity || maxCount === -Infinity) {
    minCount = 0;
    maxCount = 0;
  }
  const radiusForCount = (count) => {
    if (maxCount === minCount) return 8;
    // scale count to range [4, 15]
    const ratio = (count - minCount) / (maxCount - minCount);
    return 4 + ratio * 11;
  };

  return (
    <div className="w-full h-80">
      <MapContainer center={[20, 0]} zoom={2} style={{ height: '100%', width: '100%' }} scrollWheelZoom={false}>
        <TileLayer 
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" 
          attribution="&copy; OpenStreetMap contributors" 
        />
        {data.map((city, idx) => (
          <CircleMarker 
            key={idx} 
            center={[city.lat, city.lon]} 
            radius={radiusForCount(city.count)} 
            fillOpacity={0.7} 
            stroke={false} 
            fillColor="#4D62F4"
          >
            <Popup>{city.city}: {city.count} scans</Popup>
          </CircleMarker>
        ))}
      </MapContainer>
    </div>
  );
}

export default CityMap;

